module.exports = "/static/images/Silver-Fork-Winery.jpg";